import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/600.css";
import "@fontsource/ibm-plex-mono/400.css";
import {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import {App} from "./App";
import "./styles/tokens.css";
import "./styles/app.css";
import "./styles/responsive.css";

createRoot(document.getElementById("root")!).render(<StrictMode><App/></StrictMode>);
